import ReactModal from "react-modal";

ReactModal.setAppElement("#root");

const Modal = (props) => {
  const { isModalOpen, onRequestClose, overlay, content, children } = props;

  return (
    <ReactModal
      isOpen={isModalOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          backdropFilter: "blur(1px)",
          backgroundColor: "rgb(28 27 33 / 75%)",
          ...(overlay || {}),
        },
        content: {
          position: "absolute",
          top: "30%",
          left: "45%",
          transform: "none",
          width: "290px",
          height: "230px",
          borderRadius: "10px",
          padding: "20px",
          border: "1px solid rgb(204 204 204 / 43%)",
          backgroundColor: "rgb(36 34 34)",
          overflow: "hidden",
          ...content,
        },
      }}
    >
      {children}
    </ReactModal>
  );
};

export default Modal;
